import { Globe2, Check } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useI18n, LOCALES } from "@/contexts/I18nContext";

export const LanguageSwitcher = ({ testid = "language-switcher-btn" }) => {
  const { locale, setLocale, t } = useI18n();
  const active = LOCALES.find((l) => l.code === locale) || LOCALES[0];
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          data-testid={testid}
          className="inline-flex items-center gap-2 h-9 px-3 rounded-full border border-border bg-card text-xs font-semibold text-foreground/75 hover:text-primary hover:border-primary/50 transition-colors"
        >
          <Globe2 className="w-4 h-4" strokeWidth={1.8} />
          <span className="font-mono">{active.flag}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56 bg-popover">
        <DropdownMenuLabel className="eyebrow">{t("action.language")}</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {LOCALES.map((l) => (
          <DropdownMenuItem
            key={l.code}
            data-testid={`language-option-${l.code}`}
            onClick={() => setLocale(l.code)}
            className="flex items-center justify-between gap-3 cursor-pointer"
          >
            <span className="flex items-center gap-2.5">
              <span className="font-mono text-[10px] w-6 text-muted-foreground">{l.flag}</span>
              <span className="text-sm font-medium">{l.native}</span>
            </span>
            {l.code === locale && <Check className="w-3.5 h-3.5 text-primary" strokeWidth={2.4} />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LanguageSwitcher;
